<template>
  <div class="container py-5 position-relative">
    <div class="row row-grid justify-content-around align-items-center ">
      <div class="col-lg-4 order-2 ">
        <div class="text-center">
          <slot name="pr-1" />
          <slot name="pr-2" />
          <slot name="pr-3" />
          <slot name="pr-4" />
        </div>
      </div>
      <div class="col-lg-7 col-md-12 my-5 order-1 ">
        <div
          class="
            card
            bg-section-secondary
            mt-7
            mb-0
            py-5
            px-4
            shadow-lg
            hover-scale-110
          "
        >
          <div class="card-body ">
            
              <slot name="pl-1" />
              <slot name="pl-2" />
              <slot name="pl-3" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'S9'
}</script>

<style>
.btn{
    transition: all .2s ease-in;
}
.zindex-100 {
  z-index: 100 !important;
}
.badge-soft-primary {
  color: var(--light);
  background-color: var(--light-primary);
}

.translate-y-n3,
.hover-translate-y-n3:hover {
  transform: translateY(-3px) !important;
  transition: 0.3s ease-in-out ;
}

.translate-y-n3,
.hover-translate-y-n3:hover {
  transform: translateY(-3px) scale(1.1) !important;
  transition: 0.3s ease-in-out ;
}
.btn-icon .btn-inner--text:not(:first-child) {
  margin-right: 0.75em;
}
.perspective-right {
  transform: scale(1) perspective(1040px) rotateY(9deg) rotateX(2deg)
    rotate(2deg);
}
[class*="shadow"] {
    transition: all 0.2s ease;
}
.bg-section-secondary {
    background-color:  var(--white) !important;
}
.card.hover-scale-110:hover {
    z-index: 2;
    border-radius: 0.375rem !important;
}
.hover-scale-110:hover {
    transform: scale(1.03) !important;
}
.lh-180 {
    line-height: 1.8 !important;
}
.icon-primary {
    color: var(--primary);
    background-color:  var(--light-primary);
}
.icon-warning {
    color: var(--yellow);
    background-color: var(--light-yellow);
}
.icon-success {
    color: var(--green);
    background-color: var(--light-green);
}
.icon-shape {
    display: inline-block;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 0.25rem;
}
.icon-sm {
    min-width: 2rem;
    min-height: 2rem;
    line-height: 2rem;
}
.rounded-circle {
    border-radius: 50% !important;
}

</style>